import { createSlice } from "@reduxjs/toolkit";

import { LEFT_DRAWER_TYPES } from "../../utils/globalConstantUtil";
import { serializeExtraObject } from "./rightDrawerSlice";


const initialState = {
  header: '',
  isOpen: false,
  bodyType: '',
  extraObject: {},
  drawerTriggeredManually: false,
  activeStage: 'overview',
}

const leftDrawerSlice = createSlice({
  name: 'leftDrawer',
  initialState,
  reducers: {
    openLeftDrawer: (state, action) => {
      const { header, bodyType, extraObject } = action.payload
      state.isOpen = true
      state.header = header
      state.bodyType = bodyType
      state.extraObject = serializeExtraObject(extraObject)
    },
    closeLeftDrawer: (state) => {
      state.isOpen = false
      state.bodyType = ''
      state.header = ''
      state.extraObject = {}
    },
    setLeftDrawerTriggeredManually: (state, action) => {
      state.drawerTriggeredManually = action.payload
    },
    setActiveStage: (state, action) => {
      state.activeStage = action.payload;
    },
    resetActiveStage: (state) => {
      state.activeStage = 'overview';
    },
  },
})

export const {
  openLeftDrawer,
  closeLeftDrawer,
  setLeftDrawerTriggeredManually,
  setActiveStage, resetActiveStage
} = leftDrawerSlice.actions

export const selectIsLeftDrawerOpen = (state) => state.leftDrawer.isOpen
export const selectLeftDrawerBodyType = (state) => state.leftDrawer.bodyType
export const selectLeftDrawerHeader = (state) => state.leftDrawer.header
export const selectLeftDrawerExtraObject = (state) => state.leftDrawer.extraObject

export default leftDrawerSlice.reducer